import { RequestParams } from "./UseCase";

export class NoParam implements RequestParams {

}